<div
  class="container"
  [ngStyle]="{ 'max-height': maxHeight() }">
  <h3>{{ 'guided-tour.g2m.intro-headline' | translate }}</h3>
  <div class="fv-intro-text-block">
    <div class="overall-text">
      <p [innerHTML]="'guided-tour.g2m.intro-text' | translate"></p>
    </div>
  </div>
</div>
